import { Typography, Box, Table, TableContainer, TableRow, TableCell, TableBody, Button, CircularProgress, IconButton, MenuItem, Tooltip, TablePagination, Paper, useTheme, Menu } from '@mui/material'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import DataLoadingSpinner from '../../components/common/DataLoadingSpinner'
import TableHeader from '../../components/common/TableHeader'
import { exportExamParticipation } from '../../utils/exam-utilities'
import noParticipationImg from '../../assets/no-participation.svg'
import BlockMessage from '../../components/common/BlockMessage'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Icons } from '../../utils/utilities'
import api from '../../service/api'
import BreadcrumbList from '../../components/common/BreadcrumbList'
import { Upload } from '@mui/icons-material'
import TryAgainMessageBlock from '../../components/common/TryAgainMessageBlock'
// import SubmitOrEditRemarkDialog from '../../components/exams-components/SubmitOrEditRemarkDialog'
import warningImg from '../../assets/warning.svg'
import { useUserStore } from '../../store/user.store'
import ConfirmDialog from '../../components/common/ConfirmDialog'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'

const ParticipationTableRow = ( { participation, columns, totalMarks, fetchParticipations } ) => {

    const [confirmDialogState, setConfirmDialogState] = useState( false )
    const [approving, setApproving] = useState( false )
    const [deleting, setDeleting] = useState( false )

    const { palette, table, theme, border } = useTheme()
    const { id } = useParams()

    const approveReattempt = async () => {
        setApproving( true )
        try {
            await api.admissionExams.approveReattempt( { user_id: participation.student_id } )
            await fetchParticipations()
        } catch ( err ) {
            console.log( err )
            toast( err?.response?.data?.message || "Something went wrong while approving the reattempt request." )
        } finally {
            setApproving( false )
        }
    }

    const deleteParticipation = async () => {
        setDeleting( true )
        try {
            const { data } = await api.admissionExams.deleteAdmissionExamParticipation( id, participation.participation_id )
            setConfirmDialogState( false )
            await fetchParticipations()
            toast( data.message )
        } catch ( err ) {
            console.log( err )
            toast( err?.response?.data?.message || err?.response?.data || "Something went wrong while deleting the participation, please try again." )
        } finally {
            setDeleting( false )
        }
    }

    return (
        <React.Fragment>

            <ConfirmDialog
                actionName="Yes! delete this attempt"
                status={confirmDialogState}
                confirmAction={deleteParticipation}
                cancelAction={() => setConfirmDialogState( false )}
                message={<p> <strong>{participation.student_name}</strong> ({participation.student_id}), attempt number: {participation.exam_participation_attempt} will be deleted permanently.</p>}
                waiting={deleting}
            />

            <TableRow sx={{ overflow: "hidden", position: "relative" }} className='table-row' >
                <TableCell sx={{ color: table.color, fontSize: "12px", minWidth: "100px" }}>
                    {participation.student_id}
                </TableCell>
                <TableCell sx={{ color: table.color, fontSize: "12px", minWidth: "100px" }}>
                    {participation.student_name}

                    {( participation?.utm_details?.utm_source || participation?.utm_details?.utm_campaign ) && <Box sx={{ display: "flex", gap: "5px" }} >
                        {participation?.utm_details?.utm_source && <Typography sx={{ display: "block", borderRadius: "5px", bgcolor: palette.contentBg, border: `1px solid ${palette.text.primary}`, padding: "2px" }} fontSize="10px">
                            Source: {participation?.utm_details?.utm_source}
                        </Typography>}
                        {participation?.utm_details?.utm_campaign && <Typography sx={{ display: "block", borderRadius: "5px", bgcolor: palette.contentBg, border: `1px solid ${palette.text.primary}`, padding: "2px" }} fontSize="10px">
                            Campaign: {participation?.utm_details?.utm_campaign}
                        </Typography>}
                    </Box>}

                </TableCell>
                <TableCell align='center' sx={{ color: table.color, fontSize: "12px", minWidth: "80px" }}>
                    {participation.exam_participation_attempt}
                </TableCell>
                <TableCell sx={{ color: table.color, padding: "0" }}>
                    <Box padding={columns[3].padding || "10px 20px"}>
                        <Typography color="inherit" variant="body2" sx={{ textTransform: "uppercase", minWidth: "100px", fontSize: "12px !important" }}>

                            {participation.exam_participation_status === 'Completed' && <Typography component="span" sx={{ fontSize: "inherit", color: "inherit" }}  >completed <Typography component="span" sx={{ display: "block", color: "inherit", textTransform: "capitalize", fontSize: "inherit" }}>at {dayjs( participation.exam_participation_end_time ).format( "D-M-YYYY, hh:mm A" )}</Typography></Typography>}
                            {participation.exam_participation_status === 'In progress' && <Typography component="span" sx={{ fontSize: "inherit", color: "inherit" }} >In progress <Typography component="span" sx={{ display: "block", color: "inherit", textTransform: "capitalize", fontSize: "inherit" }}>Started: {dayjs( participation.exam_participation_start_time ).format( "D-M-YYYY, hh:mm A" )}</Typography></Typography>}
                            {!["Completed", "In progress"].includes( participation.exam_participation_status ) && participation.exam_participation_status}

                        </Typography>
                    </Box>
                </TableCell>
                <TableCell align='left' sx={{ color: table.color, padding: 0, minHeight: "100%", minWidth: "120px", gap: "5px", fontWeight: "bold" }} >
                    <Typography fontSize="14px" fontWeight={500} padding={columns[4].padding || "10px 20px"}>{participation.exam_participation_score ? participation.exam_participation_score : "0"} out of {totalMarks}</Typography>
                </TableCell>
                <TableCell align='left' sx={{ color: table.color, minHeight: "100%", minWidth: "140px", gap: "5px", fontWeight: "bold", padding: columns[4].padding || "10px 20px" }} >
                    <Typography fontSize="12px">
                        {participation.participation_result_status !== "NOT_SET" ? participation.participation_result_status : "NA"}
                    </Typography>
                    {participation.reattempt_requested && <Typography color='error' fontSize="10px">
                        Reattempt Requested
                    </Typography>}
                    {participation.allow_reattempt && <Typography color='success' fontSize="10px">
                        Reattempt Approved
                    </Typography>}
                </TableCell>
                <TableCell align='right' sx={{ overflow: "hidden", color: table.color, minWidth: "270px", padding: "0", zIndex: "10", backgroundColor: palette.background.paper }}>
                    <Box sx={{ padding: columns[5].padding || "10px 20px", }} display="flex" flexWrap="wrap" marginLeft="5px" gap="5px" justifyContent="flex-end" alignItems="center">
                        {participation.reattempt_requested && <Button size="small" disabled={approving} variant='contained' startIcon={approving ? <CircularProgress size={14} /> : Icons.default.CheckCircleIcon} onClick={approveReattempt} color="secondary" sx={{ textTransform: "capitalize", borderRadius: "20px", flexShrink: 0 }}>Approve Reattempt</Button>}
                        <Link to={`/admission-exam/${id}/evaluate/${participation.participation_id}`} className="default-link">
                            {/* <Button size="small" variant='outlined' color="secondary" sx={{ textTransform: "capitalize" }}>Evaluate</Button> */}
                            <IconButton size='small' color='secondary'>
                                {Icons.default.OpenInNewIcon}
                            </IconButton>
                        </Link>
                        <IconButton size='small' onClick={() => setConfirmDialogState( true )} color='errorMessage'>
                            {Icons.default.DeleteIcon}
                        </IconButton>
                    </Box>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}

export default function AdmissionExamParticipation () {

    const { id } = useParams()
    const [participations, setParticipations] = useState( [] )
    const [totalMarks, setTotalMarks] = useState( 0 )
    const [loading, setLoading] = useState( true )
    const [exam, setExam] = useState( null )
    const [filteredParticipations, setFilteredParticipations] = useState( [] )
    const [rowsPerPage, setRowsPerPage] = useState( 10 )
    const [page, setPage] = useState( 0 )
    const [sortState, setSortState] = useState( {} )
    const [error, setError] = useState( null )
    const [attemptsMenuOpen, setAttemptsMenuOpen] = useState( false )
    const [accessDenied, setAccessDenied] = useState( false )
    const [hasPermission, setHasPermission] = useState( true )


    const navigate = useNavigate()
    const { palette, border, table, theme } = useTheme()

    const UserStore = useUserStore()

    const attemptsMenuRef = useRef()

    const [searchParams, setSearchParams] = useSearchParams( { selectedAttempt: "0" } )
    const selectedAttempt = searchParams.get( 'selectedAttempt' )

    const setSearchParamValue = useCallback( ( key, val ) => {
        setSearchParams( prev => {
            prev.set( key, val )
            return prev
        }, { replace: true } )
    }, [setSearchParams] )

    const handleAttemptChange = useCallback( ( val = selectedAttempt, data = participations, changeValue = true ) => {
        if ( changeValue )
            setSearchParamValue( 'selectedAttempt', val )
        if ( val === 'latest' ) {
            const groupByID = data.reduce( ( dict, item ) => {
                if ( dict[item.student_id] ) {
                    if ( parseInt( dict[item.student_id].exam_participation_attempt ) < item.exam_participation_attempt )
                        dict[item.student_id] = item
                } else
                    dict[item.student_id] = item
                return dict
            }, {} )
            setFilteredParticipations( Object.values( groupByID ) )
        } else if ( +val !== 0 ) {
            const filteredList = data.filter( p => String( p.exam_participation_attempt ) === String( val ) )
            setFilteredParticipations( filteredList )
        } else if ( +val === 0 ) {
            setFilteredParticipations( data )
        }
        setAttemptsMenuOpen( false )
    }, [participations, selectedAttempt, setSearchParamValue] )

    const sortByProperty = ( property ) => {
        let newFilteredParticipations = [...filteredParticipations]
        newFilteredParticipations.sort( ( a, b ) => {
            if ( typeof a[property] == "number" ) {
                if ( !sortState[property] )
                    return ( a[property] - b[property] )
                else
                    return ( b[property] - a[property] )
            } else {
                if ( !sortState[property] )
                    return ( ( a[property] < b[property] ) ? -1 : 0 )
                else
                    return ( ( a[property] > b[property] ) ? -1 : 0 )
            }
        } )
        setSortState( { ...sortState, [property]: sortState[property] ? false : true } )
        setFilteredParticipations( newFilteredParticipations )
    }

    const handleChangePage = ( event, newPage ) => {
        setPage( newPage )
    }

    const handleChangeRowsPerPage = ( event ) => {
        setRowsPerPage( parseInt( event.target.value, 10 ) )
        setPage( 0 )
    }

    const getData = useCallback( async () => {
        try {
            setLoading( true )
            const { data: participationData } = await api.admissionExams.fetchExamParticipation( id )
            setParticipations( participationData.participations )
            if ( selectedAttempt === 'latest' ) {
                const groupByID = participationData.participations.reduce( ( dict, item ) => {
                    if ( dict[item.student_id] ) {
                        if ( parseInt( dict[item.student_id].exam_participation_attempt ) < item.exam_participation_attempt )
                            dict[item.student_id] = item
                    } else
                        dict[item.student_id] = item
                    return dict
                }, {} )
                setFilteredParticipations( Object.values( groupByID ) )
            } else if ( +selectedAttempt !== 0 ) {
                const filteredList = participationData.participations.filter( p => String( p.exam_participation_attempt ) === String( selectedAttempt ) )
                setFilteredParticipations( filteredList )
            } else if ( +selectedAttempt === 0 ) {
                setFilteredParticipations( participationData.participations || [] )
            }
            setTotalMarks( participationData.totalMarks )
            setExam( participationData.exam )
            setError( null )
        } catch ( err ) {
            console.log( err )
            if ( err?.response?.status === 403 || err?.response?.status === 401 )
                setAccessDenied( true )
            else
                setError( { code: err?.response?.status, message: err?.response?.data?.message || err?.response?.data || "Something went wrong, try again later!" } )
        }
        finally {
            setLoading( false )
        }
    }, [id, selectedAttempt] )



    useEffect( () => {
        if ( UserStore.getUser.user_role === 'subadmin' && !UserStore.getUser.user_permissions.exams ) {
            setHasPermission( false )
        }
    }, [UserStore] )

    useEffect( () => {
        getData()
    }, [getData] )


    const columns = [
        { name: "Candidate ID", color: "white", minWidth: "150px", align: "left", padding: "10px 20px 10px 20px" },
        {
            name: <Box width="fit-content" display="flex" gap="10px" alignItems="flex-start">
                Candidate name <IconButton onClick={() => { sortByProperty( "student_name" ) }} sx={{ color: "inherit", width: "20px", height: "20px", "&:hover": { color: "GrayText" } }} size='small'>
                    {sortState.student_name ? <ArrowDownwardIcon sx={{ fontSize: "14px" }} /> : <ArrowUpwardIcon sx={{ fontSize: "14px" }} />}
                </IconButton>
            </Box>, color: "white", minWidth: "200px", align: "left"
        },
        { name: "attempt", color: "white", width: "10px", align: "right" },
        { background: "#f18f08", color: "white", name: "Status", minWidth: "200px" },
        {
            background: "#f18f08", minWidth: "120px", color: "white", name: <Box justifyContent="flex-start" display="flex" gap="10px" alignItems="center">
                Score <IconButton onClick={() => { sortByProperty( "exam_participation_score" ) }} sx={{ color: "inherit", width: "20px", height: "20px", "&:hover": { color: "GrayText" } }} size='small'>
                    {sortState.exam_participation_score ? <ArrowDownwardIcon sx={{ fontSize: "14px" }} /> : <ArrowUpwardIcon sx={{ fontSize: "14px" }} />}
                </IconButton>
            </Box>, align: "right", padding: "10px 20px 10px 20px"
        },
        { name: "Result", color: "white", width: "10px" },
        // { name: "Device", minWidth: "150px" },
        // { name: "Submission by", minWidth: "150px", padding: "10px 40px 10px 20px" },
        // { name: "Remarks", minWidth: "150px" },
        { name: "", align: "right", padding: "10px 20px 10px 20px", styles: { zIndex: 20 } }
    ]

    return (
        hasPermission ? <Box display="flex" padding={{ xs: "10px", md: "20px" }} overflow="auto" flexDirection="column" height="100%" flexGrow={1} minWidth="0">


            {accessDenied && <BlockMessage actions={[{ label: "Back to Participations", action: () => navigate( `/faculty/participations` ) }]} type='error' message='You do not have access to view this exam information.' />}

            {/* {attemptForRemark && <SubmitOrEditRemarkDialog getData={getData} mode={remarkMode} attempt={attemptForRemark} setAttempt={setAttemptForRemark} anchor={remarkDialogAnchor} setAnchor={setRemarkDialogAnchor} />} */}

            {!accessDenied && !error &&
                <BreadcrumbList items={[
                    { link: "/admission-exam", label: "Exams" },
                    { link: `/admission-exam/exam/${id}`, label: exam ? exam.exam_name : <CircularProgress sx={{ color: "textSecondary" }} size={12} /> },
                    "Participations"
                ]} />}

            {!accessDenied && <Paper sx={{ minHeight: !loading && "350px", flexGrow: !loading && !error && 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                {exam && <Box gap="20px" sx={{ background: `linear-gradient(233.69deg, #6A6790 -93.75%, #1F1E2A 145.73%)` }} padding="20px" display="flex" alignItems={{ lg: "center", md: "center", sm: "center", xs: "flex-start" }} justifyContent="space-between" flexDirection={{ lg: "row", md: "row", sm: "row", xs: "column" }} >
                    <Box>
                        <Typography color="white" variant='h5'>{exam.exam_name} </Typography>
                        <Typography color="white" variant='body2'>Participations</Typography>
                    </Box>
                    {participations && participations.length > 0 && <Box display="flex" flexDirection={{ lg: "row", md: "row", sm: "row", xs: "column" }} gap="20px" width={{ lg: "fit-content", md: "fit-content", sm: "fit-content", xs: "100%" }} >
                        <Button ref={attemptsMenuRef} onClick={() => setAttemptsMenuOpen( true )} endIcon={Icons.default.KeyboardArrowDownIcon} variant='contained' disableElevation sx={{ background: `linear-gradient(125.39deg, #139CFF -32.54%, #C54097 110.4%)`, }} >
                            <Typography variant='subtitle2' color="white">{selectedAttempt === "0" ? "All attempts" : `Attempt: ${selectedAttempt}`}</Typography>
                        </Button>
                        <Menu anchorEl={attemptsMenuRef.current} open={attemptsMenuOpen} onClose={() => setAttemptsMenuOpen( false )}>
                            <MenuItem onClick={() => handleAttemptChange( "0" )} sx={{ fontSize: "14px" }} value={"0"}>All attempts</MenuItem>
                            <MenuItem onClick={() => handleAttemptChange( "latest" )} sx={{ fontSize: "14px" }} value="latest">Latest attempt</MenuItem>
                            {new Array( parseInt( Math.min( 10, exam.maximum_attempts ) ) ).fill( 1 ).map( ( e, index ) => (
                                <MenuItem onClick={() => handleAttemptChange( index + 1 )} sx={{ fontSize: "14px" }} key={index} value={index + 1}>Attempt - {index + 1}</MenuItem>
                            ) )}
                        </Menu>

                        <Tooltip title="Export participation data as CSV file">
                            <Button disableElevation onClick={() => exportExamParticipation( participations, totalMarks )} sx={{ width: { sm: "150px", xs: "100%" } }} variant='contained' color='customThemeColor' endIcon={<Upload />}>
                                Export All
                            </Button>
                        </Tooltip>
                    </Box>}
                </Box>}
                {!loading && !error && participations && participations.length > 0 &&
                    <Box margin="20px" border={border[1]} borderRadius="5px" flexGrow={1} display="flex" flexDirection="column" minHeight="300px" overflow="hidden">
                        {filteredParticipations.length > 0 && <TableContainer className='custom-scrollbar' sx={{ flexGrow: 1, overflow: "auto", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                            <Table stickyHeader>
                                <TableHeader columns={columns} />
                                <TableBody>
                                    {filteredParticipations
                                        .slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                        .map( ( participation, index ) => (
                                            <ParticipationTableRow fetchParticipations={getData} totalMarks={totalMarks} columns={columns} key={participation.participation_id} participation={participation} />
                                        ) )}
                                </TableBody>
                            </Table>
                        </TableContainer >}
                        {filteredParticipations.length > 0 && <TablePagination
                            sx={{ background: table.headerBg, position: "sticky", bottom: 0, right: 0, left: 0, minHeight: "55px" }}
                            rowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
                            component="div"
                            className='no-scrollbar'
                            count={filteredParticipations.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />}
                        {filteredParticipations.length === 0 && <Box height="100%" flexGrow={1} padding="20px" bgcolor={palette.contentBg} margin="10px" borderRadius="5px" display="flex" flexDirection="column" gap="10px" justifyContent={'center'} alignItems="center">
                            <img width="200px" src={noParticipationImg} alt="No participtions" />
                            <Typography padding="20px" variant='subtitle2' >No participants for selected attempt number!</Typography>
                            <Button startIcon={Icons.default.FilterAltOff} sx={{ textTransform: "capitalize" }} variant='outlined' color='error' >Remove filter</Button>
                        </Box>}
                    </Box>
                }
                {!loading && !error && participations.length === 0 && <Box height="100%" flexGrow={1} padding="20px" bgcolor={palette.contentBg} margin="10px" borderRadius="5px" display="flex" flexDirection="column" gap="10px" justifyContent={'center'} alignItems="center">
                    <img width="200px" src={noParticipationImg} alt="No participtions" />
                    <Typography padding="20px" variant='subtitle2' >No participants yet!</Typography>
                </Box>}
                {loading && !error && <DataLoadingSpinner waitingMessage="Loading exam participations..." />}
                {error && <TryAgainMessageBlock imageHeight='250px' err={error?.message} code={error.code} loading={loading} getData={getData} />}
            </Paper >}
        </Box > : <Box minHeight="0" display="flex" flexDirection="column" overflow="auto" flexGrow={1} minWidth="0">
            <Paper sx={{ display: "flex", justifyContent: "center", padding: "20px", gap: "20px", alignItems: "center" }}>
                <img src={warningImg} width="40px" alt="No permission" />
                <Typography variant='subtitle2' color="textSecondary">You doesn't have permission to access this page!</Typography>
            </Paper>
        </Box>
    )
}
